var map = {
	"./two": 3
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2;



/*****************
 ** WEBPACK FOOTER
 ** ./chunks/context ^\.\/.*o$
 ** module id = 2
 ** module chunks = 1
 **/